const stripHtmlFromString = (text: string | undefined) => {
  return (text || '')
    .replace(/<[^>]*>?/gm, '')
    .replace(/\&nbsp\;/gm, ' ')
    .replace(/\[\d+\]/gm, ' ');
};

export default stripHtmlFromString;
